import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import ProcessSection from '../products/custom-stretch-tents/components/ProcessSection';
import BottomCTA from './components/BottomCTA';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

const contactJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${siteUrl}/#business`,
  name: 'Pop Pro Tents',
  url: siteUrl,
  description: 'Premium stretch tent rentals in Austin, Texas for weddings, festivals, corporate and private events. Expert installation with free quotations.',
  telephone: '+1-656-347-7380',
  email: 'info@popprotents.com',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Austin',
    addressRegion: 'TX',
    addressCountry: 'US',
  },
  areaServed: [
    { '@type': 'State', name: 'Texas' },
    { '@type': 'Country', name: 'United States' },
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'sales',
    telephone: '+1-656-347-7380',
    email: 'info@popprotents.com',
    availableLanguage: ['English'],
    areaServed: ['US'],
  },
  sameAs: [
    'https://www.instagram.com/popprotents/',
    'https://www.facebook.com/popprotents/',
  ],
};

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(contactJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <ContactSection />
        <ProcessSection />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}